import React from "react";
import FAQ from "@airasia/phoenix-widgets/widgets/FAQ";
import _ from "lodash";
import { withPrefix } from "gatsby";

export default function ItemCarousel(props) {
    
    const faqData = props.data.map((item, index) => {
        return {
            answer :item.answer,
            question: item.question,
        };
    });
    
    return (
        <FAQ
            data={[...faqData]}
            displayIndex={false}
            size={{}}
            theme="AIRASIA_CLASSIC"
            titleMarginBottom="normal"
            titleType="h3"
        />
    );
}
